import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComposerStateService } from '../services/composer-state.service';
import { ConnectionSide } from '../enums/connection-side.enum';

@Component({
  selector: 'app-composer-canvas',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="ipe:flex ipe:justify-center ipe:items-center ipe:gap-4 ipe:overflow-x-auto ipe:py-10 ipe:px-4">
      <button
        [disabled]="!state.canAddLeft()"
        class="
            ipe:w-10 ipe:h-10 ipe:rounded-full ipe:border
            ipe:flex ipe:items-center ipe:justify-center
            ipe:transition
            ipe:border-gray-400 ipe:text-gray-700
            ipe:hover:bg-gray-200
            ipe:disabled:opacity-40
            ipe:disabled:cursor-not-allowed
            ipe:disabled:hover:bg-transparent
            ipe:cursor-pointer
         "
        [class.ipe:text-sky-400]="state.activeSide() === 'left'"
        [class.ipe:border-sky-400]="state.activeSide() === 'left'"
        (click)="state.openSelector(ConnectionSide.Left)"
      >
        +
      </button>
      @if (state.composition().length) {
        <div class="ipe:flex ipe:gap-6 ipe:max-w-[80%] ipe:overflow-x-auto ipe:bg-white ipe:pb-3">
          @for (item of state.composition(); let i = $index; track item.uid) {
            <button
              [class.ipe:border-sky-400]="state.activeItem()?.uid === item.uid"
              (click)="state.selectItem(item)"
              class="ipe:relative ipe:group ipe:flex-shrink-0 ipe:text-left ipe:flex-grow ipe:rounded-xl ipe:border ipe:border-[#ede8e3] ipe:overflow-hidden
                       ipe:hover:shadow-lg ipe:transition ipe:cursor-pointer
                       ipe:disabled:opacity-40 ipe:disabled:cursor-not-allowed"
            >
              <div class="ipe:h-40 ipe:bg-[#d6cdc0] ipe:flex ipe:items-center ipe:justify-center">
                <img [src]="item.element.image" class="ipe:h-full ipe:object-contain ipe:p-4"/>
              </div>

              <div class="ipe:p-4">
                <div class="ipe:font-medium">{{ item.element.id }}</div>
                <div class="ipe:text-sm ipe:text-gray-500">Type {{ item.element.type }}</div>
              </div>
              @if (state.canRemoveAt(i)) {
                <button class="ipe:absolute ipe:top-2 ipe:right-2 ipe:bg-white ipe:border ipe:border-gray-300
                     ipe:text-red-600 ipe:p-1.5 ipe:rounded-full ipe:shadow ipe:w-10 ipe:h-10 ipe:cursor-pointer
                     ipe:opacity-0 ipe:group-hover:opacity-100 ipe:transition"
                        (click)="state.remove(item)"
                >
                  ✕
                </button>
              }
            </button>
          }
        </div>
      } @else {
        <p>Aggiungi il tuo primo elemento</p>
      }
      <button
        [disabled]="!state.canAddRight()"
        (click)="state.openSelector(ConnectionSide.Right)"
        class="
            ipe:w-10 ipe:h-10 ipe:rounded-full ipe:border
            ipe:flex ipe:items-center ipe:justify-center
            ipe:transition
            ipe:border-gray-400 ipe:text-gray-700
            ipe:hover:bg-gray-200
            ipe:disabled:opacity-40
            ipe:disabled:cursor-not-allowed
            ipe:disabled:hover:bg-transparent
            ipe:cursor-pointer
         "
        [class.ipe:text-sky-400]="state.activeSide() === 'right'"
        [class.ipe:border-sky-400]="state.activeSide() === 'right'"
      >
        +
      </button>
    </div>
  `,
  styles: [`:host {width: 100%}`]
})
export class ComposerCanvasComponent {
  readonly state = inject(ComposerStateService);
  readonly ConnectionSide = ConnectionSide;
}
